/**
 * 上传文件的访问权限
 */
export enum ObjectAcl {
  /**
   * 继承Bucket
   */
  DEFAULT = 0,

  /**
   * 公共读写
   */
  PUBLIC_READ_WRITE = 1,

  /**
   * 公共读
   */
  PUBLIC_READ = 2,

  /**
   * 私有
   */
  PRIVATE = 3
}
